<template>
    <div>
        <Header></Header>
        <div>
            <div class="card-block">
                <h1>Добавление новой парковки<router-link class="button _free _second" to="/parking">К списку</router-link></h1>

                <form class="card" :loading="status">
                    <div class="inline">
                        <div class="grid">
                            <CoordsPicker :address.sync="data.address" :lat.sync="data.lat" :lng.sync="data.lng"></CoordsPicker>
                            <div class="form-item">
                                <label for="descr">Описание</label>
                                <input type="text" id="descr" class="text-input" v-model="data.description" />
                            </div>
                        </div>
                    </div>
                </form>
                <div class="submit button _free" v-show="showButton" @click="add()">Добавить парковку</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import CoordsPicker from '@/components/CoordsPicker.vue'

    export default {
        components: {
            Header,
            CoordsPicker
        },
        data () {
            return {
                status: '',
                data: {
                    address: '',
                    description: '',
                    lat: '',
                    lng: ''
                }
            }
        },
        computed: {
            showButton () {
                if (this.data.address == '' || this.data.lat == '' || this.data.lng == '') {
                    return false
                }
                return true
            }
        },
        methods: {
            add () {
                let json = JSON.stringify({
                    lat: this.data.lat,
                    lng: this.data.lng,
                    address: this.data.address,
                    description: this.data.description,
                })
                return new Promise((resolve, reject) => {
                    this.status = 'loading'
                    this.axios.post('api/admin/v2/parking', json, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then((resp) => {
                        this.status = ''
                        this.$router.push('/parking/' + resp.data.response.id)
                        resolve()
                    }).catch(() => {
                        this.status = ''
                        let msg = {
                            message: 'Ошибка при создании парковки',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        reject()
                    })
                })
            }
        }
    }
</script>